export default __webpack_public_path__ + "static/media/message_gray.29b3c3a5.svg";